/* disabling the following lint rule until deciding how to proceed with this file */
/* TODO:: remove the lint disable */
/* eslint-disable default-param-last */
export default initialState =>
  reducerMap =>
  (state = initialState, action) => {
    const reducer = reducerMap[action.type];
    return reducer ? reducer(state, action) : state;
  };
